<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!--api- 1  -->
        <v-card v-if="selection_data!=null" class="no-display box">
           <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Receipt Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
        </v-toolbar>
            <v-card-text>
                <v-row justify="center">
                    <!-- <v-col sm="5">
                        <h3>Receipt Report</h3>
                    </v-col> -->
                </v-row>
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox dense rounded  required v-model="current_academic_year" :items="selection_data.academic_year_list" item-text="Academic Year" label="Academic Year" outlined />
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox dense rounded required v-model="std" :items="selection_data.standard_list" item-text="Standard" label="Standard" outlined />
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox dense rounded required v-model="fees_type" :items="selection_data.fees_deposite_type" item-text="Fees Type" label="Fees Type" outlined />
                    </v-col>
                    <v-col sm="2">
                        <v-btn rounded class="mt-6 box" @click="getReceiptReport" :loading="fetch_btn_load">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <!-- api-1 ends -->
        <br />
        <!-- api-2 -->

        <v-card class="box">
           <v-toolbar flat dense class="toolbar">
            <v-toolbar-title>Report</v-toolbar-title>
           </v-toolbar>
           <div id="my-table-id">
            <v-data-table id="print" :headers="header_list" :items="records" sort-by class="elevation-1 mytable" dense :search="search">
                <template v-slot:top>
                    <v-toolbar flat dense color="white" align="center" justify="center">
                        <!-- <v-toolbar-title>Report</v-toolbar-title>

                        <v-divider class="mx-4" inset vertical></v-divider> -->
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details class="no-display"></v-text-field>

                        <v-btn  class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>

                        <!-- <download-excel v-if="records.length != 0" color="primary" dark :data="records" :fields="xls_header" worksheet="My Worksheet" name="Receipt Report.xls" :title="xls_title">
                            <v-btn  class="ma-2 no-display" tile outlined color="success">
                                <v-icon left>mdi-file-excel</v-icon> Excel
                                <v-icon right>mdi-download</v-icon>
                            </v-btn>
                        </download-excel> -->
                        <v-btn v-if="records.length != 0" class="ma-2 no-display" rounded  color="success"   outlined  @click="fnExcelReport('my-table-id', 'ReceiptReport')"  :loading="loader"
            ><v-icon color="success">mdi-export</v-icon>Export</v-btn
          >
                    </v-toolbar>
                </template>
            </v-data-table>
            </div>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            isValid: true,
            snackbar_msg: "",
            color: "",
            snackbar: false,

            //1
            current_academic_year: null,
            fees_type: null,
            std: null,
            selection_data: null,
            //2
            order: 1,
            //loader
            report_loader: true,
            fetch_btn_load: false,
            records: [],
            header_list: [],
            xls_header: [],
            xls_title: [],
            search: "",
        }),
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                /*window.onbeforeprint = function() {
        that.$store.state.drawer = false;
      };*/
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },

            getReceiptReport() {
                const data = {
                    academic_year: this.current_academic_year,
                    standard: this.std,
                    fees_type: this.fees_type,
                };
                axios
                    .post("/Account/getReceiptReport", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.status == "YES") {
                                this.records = res.data.records;
                                this.header_list = res.data.header_list;
                                this.xls_header = res.data.xls_header;
                            } else {
                                this.showSnackbar("#b71c1c", res.data.status_reason);
                                this.records = null;
                                this.header_list = null;
                                this.xls_header = null;
                            }
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
            this.report_loader = true;
            axios
                .post("/Account/receiptReport")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.selection_data = res.data.selection_data;
                        this.current_academic_year = res.data.selection_data.current_academic_year;
                        this.std = this.selection_data.standard_list[0];
                        this.fees_type = this.selection_data.fees_deposite_type[0];
                        this.load = true;
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.report_loader = false;
                });
        },
    };
</script>
<style scoped>
    @media print {
        @page {
            size: landscape;
        }
        body {
            height: 100%;
            width: 100%;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"] {
            display: none !important;
        }
        .v-data-footer,
        .v-data-footer__select,
        .v-data-footer__pagination {
            display: none !important;
            visibility: hidden !important;
        }
        .v-data-table table,
        .v-data-table__wrapper {
            width: 100% !important;
            display: block !important;
        }
    }
      .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
